import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import OTPInput, { ResendOTP } from "otp-input-react";
import { useLocation, useNavigate } from "react-router-dom";
import { ResendCode, ConfirmCode } from "../functions/authenticate";
import bannerBgSVG from "../assets/media/banner_bg.svg";

export default function PassCode() {
  const [otp, setOtp] = useState(null);
  const [username, setUsername] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [load, setLoad] = useState(false);
  const [type, setType] = useState();
  useEffect(() => {
    let { state } = location;
    console.log(location);
    if (state && state.username && state.type) {
      setUsername(state.username);
      setType(state.type);
      setTimeout(() => {
        setShow(true);
      }, 30000);
    } else {
      navigate("../login");
    }
  }, [location]);

  return (
    <Grid container>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgLeftBg" sx={{backgroundImage: `url(${bannerBgSVG})`}}>
        <Grid className="logoDiv">
          <img src="media/logo.svg" className="logoImg" />
        </Grid>
        <Grid className="roboDiv">
          <img src="media/lock_2.svg" className="roboImg" />
        </Grid>
      </Grid>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgRightBg">
        <div className="insideCont customInside2">
          <h1 className="lgTitle">Enter 6 - digit code</h1>
          <p className="lgDesc">
            Please check your email. we have sent a 6 digit code to {username}{" "}
            <a href="/forgot-password">Change</a>
          </p>

          <OTPInput
            value={otp}
            onChange={setOtp}
            autoFocus
            className="formtext customOtp"
            OTPLength={6}
            otpType="number"
            disabled={false}
          />
          {show && (
            <div className="resentxt">
              <Button
                type="button"
                onClick={() => {
                  ResendCode(username, setShow);
                }}
                className="resentxt"
              >
                Resend Code
              </Button>
            </div>
          )}
          <Button
            className="frmbtn"
            onClick={() => {
              ConfirmCode(username, otp, setLoad, navigate, type);
            }}
          >
            VERIFY
          </Button>
        </div>
      </Grid>
    </Grid>
  );
}
